import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Card, CardBody, CardFooter, CardHeader} from "reactstrap";

class DashboardPlaceholder extends Component {
    render() {
        const {title, body, callToAction, width} = this.props;

        return (
            <Card style={{width: width}}>
                <CardHeader>
                    <h3 className="text-center">{title}</h3>
                </CardHeader>
                <CardBody>
                    <div className="d-flex flex-column align-items-center">
                        <hr/>
                        {
                            typeof body === 'string' ? (
                                <p>
                                    {body}
                                </p>
                            ) : body
                        }
                    </div>
                </CardBody>
                {
                    callToAction && (
                        <CardFooter>
                            {callToAction}
                        </CardFooter>
                    )
                }
            </Card>
        );
    }
}

DashboardPlaceholder.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    callToAction: PropTypes.object,
    width: PropTypes.string
};

DashboardPlaceholder.defaultProps = {
    width: '75%'
};

export default DashboardPlaceholder;


// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardPlaceholder.js